// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"cb9d41d7","291":"ddc6a02e","312":"92fdf38f","680":"d44a61e9","833":"6c46a4ce","939":"e896f48c","956":"a551e3f1"}[chunkId] + ".chunk.js";
};